import React from 'react'
import propTypes from 'prop-types'

const CompactTable = (props) => {
  const { columns, data, tableClassname, hideHeader } = props

  const buildRow = (dt) => (
    <tr>
      {(columns || []).map(
        ({ centerData, selector, parsingFn, extraDataProps = {} }, i) => (
          <td key={i} className={centerData && 'align-center'} {...extraDataProps}>
            {parsingFn ? parsingFn(dt[selector]) : dt[selector]}
          </td>
        )
      )}
    </tr>
  )

  return (
    <table className={`table-compact ${tableClassname || ''}`}>
      {!hideHeader && (
        <thead>
          <tr>
            {(columns || []).map(
              ({ title, centerTitle, extraTitleProps = {} }, idx) => (
                <th
                  key={idx}
                  className={centerTitle && 'align-center'}
                  {...extraTitleProps}
                >
                  {title}
                </th>
              )
            )}
          </tr>
        </thead>
      )}
      <tbody>{(data || []).map((dt) => buildRow(dt))}</tbody>
    </table>
  )
}

CompactTable.propTypes = {
  data: propTypes.array,
  columns: propTypes.array,
  tableClassname: propTypes.string,
  hideHeader: propTypes.bool,
}

export default CompactTable
